/**
 * DateRangeFilter Component
 * 
 * Date picker with presets for relative dates (last 7 days, this month, etc.)
 */

import React from 'react';
import {
  HStack,
  Input,
  Select,
  Text,
} from '@chakra-ui/react';
import { RELATIVE_DATE_PRESETS } from '../../../hooks/useContactsTable';

/**
 * DateRangeFilter - Date input with relative presets
 */
export default function DateRangeFilter({
  operator,
  value,
  onChange,
}) {
  // For relative dates, show dropdown
  if (operator === 'date_relative') {
    return (
      <Select
        size="sm"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        minW="150px"
      >
        <option value="">Select period...</option>
        {Object.entries(RELATIVE_DATE_PRESETS).map(([key, preset]) => (
          <option key={key} value={key}>
            {preset.label}
          </option>
        ))}
      </Select>
    );
  }
  
  // For between, show two date inputs
  if (operator === 'date_between') {
    const [startDate, endDate] = Array.isArray(value) ? value : ['', ''];
    
    return (
      <HStack spacing={2}>
        <Input
          type="date"
          size="sm"
          value={startDate || ''}
          onChange={(e) => onChange([e.target.value, endDate])}
          maxW="140px"
        />
        <Text fontSize="sm" color="gray.500">to</Text>
        <Input
          type="date"
          size="sm"
          value={endDate || ''}
          onChange={(e) => onChange([startDate, e.target.value])}
          maxW="140px"
        />
      </HStack>
    );
  }
  
  // Default single date input
  return (
    <Input
      type="date"
      size="sm"
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      maxW="150px"
    />
  );
}
